import { portalAPI } from './portalAPI';

const APIWordPressSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        isWordPressEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/wordpress/enabled',
        }),
    }),
    overrideExisting: false,
});

export const { useIsWordPressEnabledQuery } = APIWordPressSlice;
